import {
    RECEIVE_HISTORY_CAP,
    MAX_HISTORY_CAP,
    MaxHistoryAction,
    ReceiveCapHistoryAction,
} from '../actions/CapsHistory';
import { Cap } from '../../types/caps';
import { CapHistory } from '../../features/models/api/api-types';

type UWDataActionType = ReceiveCapHistoryAction | MaxHistoryAction;
export type HistoryState = {
    byID: Record<number, CapsHistoryObject>;
    receivedAt?: number;
    fetching: boolean;
};

export type CapsHistoryObject = {
    list: CapHistory[];
    fetching: boolean;
    maxHistory: number | null;
};

const defaultState: HistoryState = {
    byID: {},
    fetching: true,
};

export default function capsHistory(state: HistoryState = defaultState, action: UWDataActionType): HistoryState {
    switch (action.type) {
        case RECEIVE_HISTORY_CAP: {
            const { data } = action;
            const list = [...(state.byID[data.capId]?.list ?? []), data];

            console.log('RECEIVE_HISTORY_CAP')

            return {
                ...state,
                byID: {
                    ...state.byID,
                    [data.capId]: { list, fetching: false, maxHistory: null },
                },
            };
        }
        case MAX_HISTORY_CAP: {
            const { capID, capHistory } = action;
            const bi = { ...state.byID };
            console.log('MAX_HISTORY_CAP')
            if (bi[capID]) {
                bi[capID] = { ...bi[capID], fetching: false, maxHistory: capHistory };
            }
            return {
                ...state,
                byID: bi,
            };
        }

        default:
            return state;
    }
}
